import { createTableApi } from '~/api/utils/create-table-api';

export const pushNotifications = {
  ...createTableApi('/timed-messages')
};
